import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Requestor, StorageBackend } from '@openid/appauth';
import { Browser } from 'ionic-appauth';
import { GlobalStateQuery } from '../state/global.appstate.query';
import { CustomAuthService } from './custom-auth.service';
import { authFactory, browserFactory, httpFactory, storageFactory } from './factories';
import { GlobalStateStore } from '../state/global.appstate.store';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: StorageBackend,
      useFactory: storageFactory,
      deps: [Platform]
    },
    {
      provide: Requestor,
      useFactory: httpFactory,
      deps: [Platform, HttpClient]
    },
    {
      provide: Browser,
      useFactory: browserFactory,
      deps: [Platform]
    },
    {
      provide: CustomAuthService,
      useFactory : authFactory,
      deps: [Platform, NgZone, Requestor, Browser, StorageBackend, GlobalStateQuery, GlobalStateStore]
    }
  ]
})
export class AuthModule { }
